import { HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { HTTP } from '@ionic-native/http';
import { Storage } from '@ionic/storage';
import { from } from 'rxjs/observable/from';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs/Rx';
import { GDAuthInterface } from '../../model/gd-auth';
import { LoopBackConfig } from '../sdk';
import { NestAuthProvider } from './nest-auth';
import { NestResponsesProvider } from './nest-responses';


@Injectable()
export class NestApiProvider {

  public payrollHost: string;
  public attendanceHost: string;
  public marketplaceHost: string;
  public gdtransferHost: string;
  public gopathNew: string;
  public staging4Host: string;
  public SFGoAuth: GDAuthInterface;
  public localhost: string = "http://localhost:3003"
  private defaultHttp: 'client' | 'native' = 'client';

  constructor(
    public http: HttpClient,
    private storage: Storage,
    public nestAuthProvider: NestAuthProvider,
    public nestResponseProvider: NestResponsesProvider,
    private httpNative: HTTP
  ) {
    this.setHost();
  }

  setDefaultHttp(http: 'client' | 'native') {
    this.defaultHttp = http;
  }

  async setHost(): Promise<void> {
    this.nestAuthProvider.setAuth.subscribe(async () => {
      this.SFGoAuth = JSON.parse(await this.storage.get('SFGoAuth'));
      const SFGoStorage = JSON.parse(await this.storage.get('SFGoStorage'));

      if (this.SFGoAuth) {
        try {
          const preLogin = SFGoStorage.storedPrelogin;

          // GET HOST ATTENDANCE
          this.attendanceHost = preLogin.hasOwnProperty('GOPATHNEW') ? preLogin.GOPATHNEW : LoopBackConfig.getPath();

          // GET GOPATH NEW
          this.gopathNew = preLogin.hasOwnProperty('GOPATHNEW') ? preLogin.GOPATHNEW : LoopBackConfig.getPath();

          // GET HOST GREATDAY TRANSFER
          this.marketplaceHost = this.SFGoAuth.marketplace

          // GET HOST MARKETPLACE
          this.gdtransferHost = this.SFGoAuth.marketplace

          // GET HOST PAYROLL
          let urlPayroll;

          try {
            if (typeof (this.SFGoAuth.payroll) == 'string') {
              urlPayroll = JSON.parse(this.SFGoAuth.payroll).url;
            } else if (typeof (this.SFGoAuth.payroll) == 'object') {
              urlPayroll = this.SFGoAuth.payroll.url;
            } else {
              urlPayroll = preLogin.hasOwnProperty('GOPATHNEW') ? preLogin.GOPATHNEW : LoopBackConfig.getPath();
            }
          } catch (error) {
            urlPayroll = preLogin.hasOwnProperty('GOPATHNEW') ? preLogin.GOPATHNEW : LoopBackConfig.getPath();
          }


          this.payrollHost = urlPayroll;
        } catch (error) {
          console.log(error);
        }

      }
    })

    this.initializeAuth();
  }

  async initializeAuth() {
    await this.storage.ready();
    const SFGoAuth = JSON.parse(await this.storage.get('SFGoAuth'));
    const SFGoStorage = JSON.parse(await this.storage.get('SFGoStorage'));

    if (SFGoAuth) {
      try {
        const preLogin = SFGoStorage.storedPrelogin;

        // GET HOST ATTENDANCE
        this.attendanceHost = preLogin.hasOwnProperty('GOPATHNEW') ? preLogin.GOPATHNEW : LoopBackConfig.getPath();

        // GET GOPATH NEW
        this.gopathNew = preLogin.hasOwnProperty('GOPATHNEW') ? preLogin.GOPATHNEW : LoopBackConfig.getPath();

        // GET HOST MARKETPLACE
        this.marketplaceHost = SFGoAuth.marketplace

        // GET HOST GREATDAY TRANSFER
        this.gdtransferHost = SFGoAuth.greatdayTransfer

        // GET HOST PAYROLL
        let urlPayroll;

        try {
          if (typeof (SFGoAuth.payroll) == 'string') {
            urlPayroll = JSON.parse(SFGoAuth.payroll).url;
          } else if (typeof (SFGoAuth.payroll) == 'object') {
            urlPayroll = SFGoAuth.payroll.url;
          } else {
            urlPayroll = preLogin.hasOwnProperty('GOPATHNEW') ? preLogin.GOPATHNEW : LoopBackConfig.getPath();;
          }
        } catch (error) {
          urlPayroll = preLogin.hasOwnProperty('GOPATHNEW') ? preLogin.GOPATHNEW : LoopBackConfig.getPath();;
        }

        this.payrollHost = urlPayroll;

        // GET STAGING4 HOST
        this.staging4Host = 'https://api.greatdayhr.com/staging4';
      } catch (error) {
        console.log(error);
      }

    }
  }

  public setBaseURL(url: string = '/'): void {
    this.gopathNew = url;
  }

  public urlBuilder(method: string, model: string, func: string, params: any, urlParams: any, service: string): string {
    let host: string;

    if (service == 'payroll') {
      host = this.payrollHost;
    } else if (service == 'attendance') {
      host = this.attendanceHost;
    } else if (service == 'localhost') {
      host = this.localhost
    } else if (service == 'marketplace') {
      host = this.marketplaceHost;
    } else if (service === 'gdtransfer') {
      host = this.gdtransferHost;
    } else if (service === 'staging4') {
      host = this.staging4Host;
    } else {
      host = this.gopathNew;
    }

    switch (method) {
      case 'GET':
        return `${host}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
      case 'POST':
        return `${host}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
      case 'DELETE':
        return `${host}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
      case 'PUT':
        return `${host}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
    }
  }

  public getPath(service?) {
    switch (service) {
      case 'attendance':
        return this.attendanceHost;
      case 'payroll':
        return this.payrollHost;
      default:
        return this.attendanceHost;
    }
  }

  public request<T>(method: string, url: string, params: any = {}, urlParams: any, body: any, contentType?: string, timeOut: number = 60000, noToken: boolean = false, recallRefreshToken: boolean = false, cfcRoute?: string | null): Observable<T> {
    if (this.defaultHttp === 'client') {
      return this.requestHttpClient(method, url, params, urlParams, body, contentType, timeOut, noToken, recallRefreshToken, cfcRoute);
    } else {
      return this.requestHttpNative(method, url, params, urlParams, body, contentType, timeOut, noToken, recallRefreshToken, cfcRoute);
    }
  }

  public requestHttpClient<T>(method: string, url: string, params: any = {}, urlParams: any, body: any, contentType?: string, timeOut: number = 60000, noToken: boolean = false, recallRefreshToken: boolean = false, cfcRoute?: string | null): Observable<T> {
    let headers: HttpHeaders;
    const whiteListPayroll = ['payrollstaging', 'git.dataon.com'];
    let count: number = 0;

    for (const item of whiteListPayroll) {
      const index = url.indexOf(item);
      if (index != -1) {
        count++;
        break;
      }
    }

    if (count > 0) {
      timeOut = (60 * 60) * 1000;
    }

    switch (contentType) {
      case 'json':
        if (this.nestAuthProvider.getAccessToken() && cfcRoute) {
          const isWebview = localStorage.getItem('webOpenFromWebview');
          if (isWebview) {
            headers = new HttpHeaders({ timeout: `${timeOut}`, recallRefreshToken: `${recallRefreshToken}` })
            .set('Authorization', this.nestAuthProvider.getAccessToken())
            .append('Content-Type', 'application/json')
            .append('route', cfcRoute)
            .append("app", "gd8");
          } else {
            headers = new HttpHeaders({ timeout: `${timeOut}`, recallRefreshToken: `${recallRefreshToken}` })
            .set('Authorization', this.nestAuthProvider.getAccessToken())
            .append('Content-Type', 'application/json')
            .append('route', cfcRoute);
          }
        }
        else if (this.nestAuthProvider.getAccessToken()) {
          const isWebview = localStorage.getItem('webOpenFromWebview');
          if (isWebview) {
            headers = new HttpHeaders({ timeout: `${timeOut}`, recallRefreshToken: `${recallRefreshToken}` })
            .set('Authorization', this.nestAuthProvider.getAccessToken())
            .append('Content-Type', 'application/json')
            .append("app", "gd8");
          } else {
            headers = new HttpHeaders({ timeout: `${timeOut}`, recallRefreshToken: `${recallRefreshToken}` })
            .set('Authorization', this.nestAuthProvider.getAccessToken())
            .append('Content-Type', 'application/json');
          }
        }
      default:
        if (this.nestAuthProvider.getAccessToken() && cfcRoute) {
          const isWebview = localStorage.getItem('webOpenFromWebview');
          if (isWebview) {
            headers = new HttpHeaders({ timeout: `${timeOut}`, recallRefreshToken: `${recallRefreshToken}` })
            .set('Authorization', this.nestAuthProvider.getAccessToken())
            .append('route', cfcRoute)
            .append("app", "gd8");
          } else {
            headers = new HttpHeaders({ timeout: `${timeOut}`, recallRefreshToken: `${recallRefreshToken}` })
            .set('Authorization', this.nestAuthProvider.getAccessToken())
            .append('route', cfcRoute);
          }
        }
        else if (this.nestAuthProvider.getAccessToken()) {
          const isWebview = localStorage.getItem('webOpenFromWebview');
          if (isWebview) {
            headers = new HttpHeaders({ timeout: `${timeOut}`, recallRefreshToken: `${recallRefreshToken}` })
            .set('Authorization', this.nestAuthProvider.getAccessToken()).append("app", "gd8");
          } else {
            headers = new HttpHeaders({ timeout: `${timeOut}`, recallRefreshToken: `${recallRefreshToken}` })
            .set('Authorization', this.nestAuthProvider.getAccessToken())
          }
        }
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.nestAuthProvider.getAccessToken(),
        'route': cfcRoute ? cfcRoute : ''
      }), body: params
    };

    if (noToken) {
      headers = new HttpHeaders({ timeout: `${timeOut}` }).append('Content-Type', 'application/json');
      const isWebview = localStorage.getItem('webOpenFromWebview');
      if (isWebview) {
        headers.append("app", "gd8");
      }
    }

    switch (method) {
      case 'GET':
        return this.http.get<T>(url, { headers });
      case 'POST':
        return this.http.post<T>(url, params || {}, { headers });
      case 'DELETE':
        return this.http.delete<T>(url, httpOptions);
      case 'PUT':
        return this.http.put<T>(url, params, { headers });
    }
  }

  public requestHttpNative<T>(method: string, url: string, params: any = {}, urlParams: any, body: any, contentType?: string, timeOut: number = 60000, noToken: boolean = false, recallRefreshToken: boolean = false, cfcRoute?: string | null): Observable<T> {
    let headers: any = {
      'Content-Type': 'application/json',
      'Authorization': '',
      'route': cfcRoute ? cfcRoute : ''
    };

    const whiteListPayroll = ['payrollstaging', 'git.dataon.com'];
    let count: number = 0;

    for (const item of whiteListPayroll) {
      const index = url.indexOf(item);
      if (index != -1) {
        count++;
        break;
      }
    }

    if (count > 0) {
      timeOut = (60 * 60) * 1000;
    }

    this.httpNative.setDataSerializer('json');
    this.httpNative.setRequestTimeout(Number(timeOut));

    switch (contentType) {
      case 'json':
        if (this.nestAuthProvider.getAccessToken()) {
          headers.Authorization = this.nestAuthProvider.getAccessToken();
        }
      default:
        if (this.nestAuthProvider.getAccessToken()) {
          headers.Authorization = this.nestAuthProvider.getAccessToken();
          delete headers['Content-Type'];
        }
    }

    if (cfcRoute) {
      headers.route = cfcRoute
    }

    switch (method) {
      case 'GET':
        const httpGET = this.httpNative.get(url, {}, headers);
        return from<any>(httpGET).pipe(map(res => JSON.parse(res.data)));
      case 'POST':
        const httpPOST = this.httpNative.post(url, params || {}, headers);
        return from<any>(httpPOST).pipe(map(res => JSON.parse(res.data)));
      case 'DELETE':
        const httpDELETE = this.httpNative.delete(url, params || {}, headers);
        return from<any>(httpDELETE).pipe(map(res => JSON.parse(res.data)));
      case 'PUT':
        const httpPUT = this.httpNative.put(url, params || {}, headers);
        return from<any>(httpPUT).pipe(map(res => JSON.parse(res.data)));
    }
  }


  public requestBlob<T>(method: string, url: string, params: any = {}, urlParams?: any, body?: any): Observable<T> {
    const headersJSON: HttpHeaders = new HttpHeaders({ timeout: `${(300 * 60) * 1000}` })
      .set('Authorization', this.nestAuthProvider.getAccessToken())
      .append('Content-Type', 'application/json');

    switch (method) {
      case 'GET':
        return this.http.get<T>(url, { headers: headersJSON, responseType: 'blob' as 'json' }).pipe(catchError(this.parseErrorBlob));

      case 'POST':
        return this.http.post<T>(url, params, { headers: headersJSON, responseType: 'blob' as 'json' }).pipe(catchError(this.parseErrorBlob));
    }
  }

  public requestUpload<T>(method: string, url: string, bodies: FormDataUpload[]): Observable<T> {
    const timeout: string = `${(300 * 60) * 1000}`;
    const token = this.nestAuthProvider.getAccessToken();

    const headers: HttpHeaders = new HttpHeaders({ timeout: timeout })
      .set('Authorization', token ? token : '')
      .set('Allow-Control-Allow-Origin', '*');

    const formData = new FormData();
    for (const body of bodies) {
      if (body.fileName) {
        formData.append(body.name, body.value, body.fileName);
      } else {
        formData.append(body.name, body.value);
      }
    }
    switch (method) {
      case 'POST':
        return this.http.post<T>(url, formData, { headers });
    }
  }

  public requestUploadWithProgress(method: string, url: string, bodies: FormDataUpload[]): Observable<HttpEvent<any>> {
    const timeout: string = `${(300 * 60) * 1000}`;
    const headers: HttpHeaders = new HttpHeaders({ timeout: timeout })
      .set('Authorization', this.nestAuthProvider.getAccessToken());

    const formData = new FormData();
    for (const body of bodies) {
      if (body.fileName) {
        formData.append(body.name, body.value, body.fileName);
      } else {
        formData.append(body.name, body.value);
      }
    }

    const request = new HttpRequest(method, url, formData, { headers: headers, reportProgress: true });
    return this.http.request<HttpEvent<any>>(request);
  }

  public requestBlobWithProgress(method: string, url: string, params: any = {}, urlParams?: any, body?: any): Observable<HttpEvent<any>> {
    let headers: HttpHeaders = new HttpHeaders()
      .set('Authorization', this.nestAuthProvider.getAccessToken())
      .append('Content-Type', 'application/json')
      .append('timeout', `${60000 * 5}`);

    let request: HttpRequest<any>;
    switch (method) {
      case 'GET':
        request = new HttpRequest(method, url, { headers: headers, reportProgress: true, responseType: 'blob' as 'json' })
        return this.http.request<HttpEvent<any>>(request);
      case 'POST':
        request = new HttpRequest(method, url, params, { headers: headers, reportProgress: true, responseType: 'blob' as 'json' })
        return this.http.request<HttpEvent<any>>(request);
    }
  }

  public requestWithOtherAuth<T>(method: string, url: string, params: any = {}, urlParams: any, body: any, contentType?: string, service?: string): Observable<T> {
    let headers: HttpHeaders;
    const timeout = 30000
    switch (service) {
      case 'gdtransfer':
        return Observable.fromPromise(this.getGdtransferAuth()).mergeMap(token => {
          headers = new HttpHeaders({ timeout: `${timeout}` })
            .set('Authorization', token)
          return this.requestMethod(method, url, headers, params, urlParams)
        });
      default:
        headers = new HttpHeaders({ timeout: `${timeout}` })
          .set('Authorization', this.nestAuthProvider.getAccessToken())
        return this.requestMethod(method, url, headers, params, urlParams)
    }
  }

  public requestMethod<T>(method: string, url: string, headers: HttpHeaders, params: any = {}, urlParams: any): Observable<T> {
    switch (method) {
      case 'GET':
        return this.http.get<T>(url, { headers });
      case 'POST':
        return this.http.post<T>(url, params, { headers });
    }
  }

  private _JSON2URL(obj: any, parent: any) {
    const parts: any = [];
    for (const key in obj)
      parts.push(this._parseParam(key, obj[key], parent));
    return parts.join('&');
  }

  private _parseParam(key: string, value: any, parent: string) {
    let processedKey = parent ? parent + '[' + key + ']' : key;
    if (value && (<string>(typeof value) === 'object' || Array.isArray(value))) {
      return this._JSON2URL(value, processedKey);
    }
    return processedKey + '=' + value;
  }

  public urlGlobalBuilder(host: string, method: string, model: string, func: string, urlParams?: any): string {
    switch (method) {
      case 'GET':
        return `${host}/${model}/${func}?${new URLSearchParams(this._JSON2URL(urlParams, false))}`;
      case `POST`:
        return `${host}/${model}/${func}`;
    }
  }

  isGoPathNewExist(): Promise<boolean> {
    return new Promise(async (resolve) => {
      const SFGoStorage = await this.storage.get('SFGoStorage');
      const storedPrelogin = SFGoStorage ? JSON.parse(SFGoStorage).storedPrelogin : {};

      if (storedPrelogin.hasOwnProperty('GOPATHNEW')) {
        resolve(true);
      } else {
        resolve(false);
      }
    })
  }

  public responseSuccess(response: { data: any, message: string }, customMessage: string): Promise<void> {
    return new Promise(async (resolve) => {
      await this.nestResponseProvider.success(response, customMessage);
      resolve();
    })
  }

  public responseError(response: HttpErrorResponse): Promise<void> {
    return new Promise(async (resolve) => {
      await this.nestResponseProvider.error(response);
      resolve();
    });
  }

  public getMessageFromBlob(err): Promise<string> {
    return new Promise<string>(resolve => {
      const fr = new FileReader();
      fr.onload = async function () {
        const res: string = this.result as string;
        const message: string = JSON.parse(res).message;
        resolve(message);
      };
      fr.readAsText(err.error);
    })
  }

  async getGdtransferAuth(): Promise<string> {
    try {
      const gdtransferAuth = JSON.parse(await this.storage.get('gdtransferAuth'));
      if (gdtransferAuth) {
        return gdtransferAuth.token;
      } else {
        return null;
      }
    } catch (error) {
      return null
    }
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();

    const obs = Observable.create((observer: any) => {
      reader.onloadend = (e) => {
        observer.error(JSON.parse(`${reader.result}`));
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
  }
}

export interface FormDataUpload {
  name: string,
  value: string | Blob,
  fileName?: string
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/nest-api.ts